export default {
  LOGIN: 'Incorrect email or password.',
  EMAIL_ALREADY_EXISTS: 'An account already exists with this email address',
};
